import type {
  SearchControlDisplayChangedAction,
  UserRequestedSearchAction,
} from '@web-platform/shared-universal-types/src/redux/banana/actions/actions-banana-types';

export const SEARCH_CONTROLS_DISPLAY_CHANGED = 'SEARCH_CONTROLS_DISPLAY_CHANGED';
export const USER_REQUESTED_SEARCH = 'USER_REQUESTED_SEARCH';

export function searchControlDisplayChanged(
  isDisplaying: boolean,
): SearchControlDisplayChangedAction {
  return {
    type: SEARCH_CONTROLS_DISPLAY_CHANGED,
    payload: {
      isDisplaying,
    },
  };
}

export function userRequestedSearch(searched: boolean): UserRequestedSearchAction {
  return {
    type: USER_REQUESTED_SEARCH,
    payload: {
      searched,
    },
  };
}
